import * as React from 'react';
import { Route } from 'react-router-dom';
import { paths } from '@/config';
import { SignIn } from '@/components/Pages';
import enhance from './enhancer';

function SignInRoutes() {
  return <Route strict path={paths.before.signin} component={SignIn} />;
}

export default enhance((props) => <SignInRoutes {...props} />);
